import {__} from "~/ts/library/Translate";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";

export default class ChatUploadHelper {
    public static sizeToString(bytes: number) {
        let sizeKb = Math.round(bytes / 1000);
        if (sizeKb < 1000) {
            return sizeKb + " " + __('Кб');
        }
        sizeKb = Math.round(sizeKb * 100 / 1000) / 100;
        return sizeKb + " " + __('Мб');
    }

    public static fileToString(file: IChatUploadFile): string {
        return `${file.filename} (${this.sizeToString(file.size)}) - ${file.url}`;
    }
}